var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsModel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_694_983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3857 2.14952C18.3857 1.66661 18.0938 1.22863 17.6445 1.04145C17.1953 0.854277 16.6825 0.959095 16.3381 1.29975L14.7059 2.93566C12.909 4.73253 10.472 5.74327 7.93018 5.74327H7.60449H6.40658H2.81283C1.49137 5.74327 0.416992 6.81766 0.416992 8.13911V11.7329C0.416992 13.0543 1.49137 14.1287 2.81283 14.1287V18.9204C2.81283 19.583 3.34814 20.1183 4.01074 20.1183H6.40658C7.06917 20.1183 7.60449 19.583 7.60449 18.9204V14.1287H7.93018C10.472 14.1287 12.909 15.1394 14.7059 16.9363L16.3381 18.5685C16.6825 18.9129 17.1953 19.0139 17.6445 18.8268C18.0938 18.6396 18.3857 18.2054 18.3857 17.7187V12.1971C19.082 11.8676 19.5837 10.9804 19.5837 9.93598C19.5837 8.89155 19.082 8.00434 18.3857 7.67492V2.14952ZM15.9899 5.02078V9.93598V14.8512C13.7887 12.8484 10.9175 11.7329 7.93018 11.7329H7.60449V8.13911H7.93018C10.9175 8.13911 13.7887 7.02355 15.9899 5.02078Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_694_983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1667,
    height: 19.1667,
    fill: "white",
    transform: "translate(0.416992 0.951813)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsModel);
export default __webpack_public_path__ + "static/media/news-model.2f946532cd37347f122f3180baa4a19b.svg";
export { ForwardRef as ReactComponent };